"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PessoaTipoDocumentacao = void 0;
const typeorm_1 = require("typeorm");
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
const pessoa_entity_1 = require("./pessoa.entity");
let PessoaTipoDocumentacao = class PessoaTipoDocumentacao extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdPessoa = void (0);
        this.cdTipoDocumentacao = void (0);
        this.nrDocumento = void (0);
        this.folha = void (0);
        this.livro = void (0);
        this.dtEmissao = void (0);
        this.cdOrgaoEmissor = void (0);
        this.tpModelo = void (0);
        this.cdCartorio = void (0);
        this.pessoa = void (0);
    }
};
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_pessoa" }),
    __metadata("design:type", Number)
], PessoaTipoDocumentacao.prototype, "cdPessoa", void 0);
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_tipo_documentacao" }),
    __metadata("design:type", Number)
], PessoaTipoDocumentacao.prototype, "cdTipoDocumentacao", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_documento", nullable: true }),
    __metadata("design:type", String)
], PessoaTipoDocumentacao.prototype, "nrDocumento", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "folha", nullable: true }),
    __metadata("design:type", String)
], PessoaTipoDocumentacao.prototype, "folha", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "livro", nullable: true }),
    __metadata("design:type", String)
], PessoaTipoDocumentacao.prototype, "livro", void 0);
__decorate([
    typeorm_1.Column('datetime', { name: 'dt_emissao', nullable: true }),
    __metadata("design:type", Date)
], PessoaTipoDocumentacao.prototype, "dtEmissao", void 0);
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_orgao_emissor" }),
    __metadata("design:type", Number)
], PessoaTipoDocumentacao.prototype, "cdOrgaoEmissor", void 0);
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "tp_modelo" }),
    __metadata("design:type", Number)
], PessoaTipoDocumentacao.prototype, "tpModelo", void 0);
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_cartorio" }),
    __metadata("design:type", Number)
], PessoaTipoDocumentacao.prototype, "cdCartorio", void 0);
__decorate([
    typeorm_1.ManyToOne(type => pessoa_entity_1.Pessoa, pessoa => pessoa.pessoasTipoDocumentacao),
    typeorm_1.JoinColumn([{ name: "cd_pessoa", referencedColumnName: "cdPessoa" }]),
    __metadata("design:type", pessoa_entity_1.Pessoa)
], PessoaTipoDocumentacao.prototype, "pessoa", void 0);
PessoaTipoDocumentacao = __decorate([
    typeorm_1.Entity('grl_pessoa_tipo_documentacao')
], PessoaTipoDocumentacao);
exports.PessoaTipoDocumentacao = PessoaTipoDocumentacao;
